import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { RandomChoiceNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

const choiceOrDefault = (value: unknown, fallback: string): string =>
  typeof value === 'string' ? value : fallback;

export const RandomChoiceNodeView = memo(function RandomChoiceNodeView({ data }: NodeProps<RandomChoiceNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const choices = [
    choiceOrDefault(data.choice1, 'A'),
    choiceOrDefault(data.choice2, 'B'),
    choiceOrDefault(data.choice3, 'C'),
  ];

  return (
    <CardShell
      kind="randomChoice"
      accent="red"
      title={getNodeDisplayLabel('randomChoice', displayLanguage)}
      summary={choices.join(' / ')}
    >
      <Handle type="target" position={Position.Left} className="!bg-red-500" />
      <Handle type="source" position={Position.Right} className="!bg-red-500" />
    </CardShell>
  );
});
